import {
    combineReducers,
    configureStore
} from '@reduxjs/toolkit';


import {ProductsReducer} from '../features/products/reducers';

// Row selection state (FNP-951). Records are React Query's job; selection is Redux's.
// FNP-1960: offers, registrations, metering-records and notification-subscriptions
// were retired with the AWS-shaped API; products is the drafts module.
const reducers = {
    products: ProductsReducer,
};

// FNP-958: a factory so tests can build an isolated store, optionally seeded.
// The test harness previously accepted a `preloadedState` argument and then
// rendered against the shared `store` singleton below, so seeding was silently
// ignored AND state leaked between test cases.
const rootReducer = combineReducers(reducers);

// FNP-930: RTK 2 types `preloadedState` against the reducer map rather than
// accepting a loose object, so the seed is now typed as a partial root state.
// `Store` is no longer annotated by hand either — inferring the store keeps the
// real dispatch type, which is what lets thunks type-check via useAppDispatch.
export const setupStore = (preloadedState?: Partial<RootState>) =>
    configureStore({
        reducer: rootReducer,
        preloadedState,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: false,
            }),
    });

export const store = setupStore();


// Infer the `RootState` and `AppDispatch` types from the reducers/store themselves
export type RootState = ReturnType<typeof rootReducer>
export type AppDispatch = typeof store.dispatch
